import type { CustomFilterProps } from "ag-grid-react";
import React from "react";
import { useSelector } from "react-redux";
import RoleTitle from "src/components/Role/Title";
import { getAllRoleIds, getRoles, getUsersById } from "src/reducers";
import type { State } from "src/types";
import MultiSelectFilter from "src/components/AgGrid/Filters/MultiSelectFilter";

const RoleFilter = (props: CustomFilterProps): React.ReactElement => {
  const usersById = useSelector(({ app }: State) => getUsersById(app));
  const roles = useSelector(({ app }: State) => getRoles(app));
  const allRoleIds = useSelector(({ app }: State) => getAllRoleIds(app));
  const data = { usersById, roles: roles as Record<number, { title: string }> };

  return (
    <MultiSelectFilter
      {...props}
      filterType="orgRole"
      data={data}
      fixedValues={allRoleIds}
      getValueFromData={(data, uid: any) => {
        const user = data.usersById[uid];
        return user?.orgRoleId ?? null;
      }}
      getSearchText={(roleId) => {
        const roleIdNum = Number(roleId);
        const role = data.roles[roleIdNum];
        return role?.title || "";
      }}
      renderValue={(roleId) => <RoleTitle roleId={Number(roleId)} />}
    />
  );
};

export default RoleFilter;
